var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDownloadReport(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 18H5C4.44772 18 4 18.4477 4 19C4 19.5523 4.44772 20 5 20H19C19.5523 20 20 19.5523 20 19C20 18.4477 19.5523 18 19 18Z",
    fill: "#407DBB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4 17V19C4 19.5523 4.44772 20 5 20C5.55228 20 6 19.5523 6 19V17C6 16.4477 5.55228 16 5 16C4.44772 16 4 16.4477 4 17Z",
    fill: "#407DBB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18 17V19C18 19.5523 18.4477 20 19 20C19.5523 20 20 19.5523 20 19V17C20 16.4477 19.5523 16 19 16C18.4477 16 18 16.4477 18 17Z",
    fill: "#407DBB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12 15C11.7927 15.0016 11.59 14.9387 11.42 14.82L7.42001 12C7.20442 11.8471 7.05815 11.615 7.01318 11.3545C6.96821 11.0941 7.02819 10.8264 7.18001 10.61C7.2558 10.5018 7.35226 10.4098 7.46382 10.3391C7.57538 10.2684 7.69983 10.2206 7.83 10.1982C7.96016 10.1759 8.09345 10.1796 8.22218 10.2091C8.35091 10.2386 8.47253 10.2933 8.58001 10.37L12 12.76L15.4 10.2C15.6122 10.0409 15.8789 9.97254 16.1414 10.0101C16.404 10.0476 16.6409 10.1878 16.8 10.4C16.9591 10.6122 17.0275 10.8789 16.99 11.1414C16.9525 11.404 16.8122 11.6409 16.6 11.8L12.6 14.8C12.4269 14.9298 12.2164 15 12 15V15Z",
    fill: "#407DBB"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12 13C11.7348 13 11.4804 12.8946 11.2929 12.7071C11.1054 12.5196 11 12.2652 11 12V4C11 3.73478 11.1054 3.48043 11.2929 3.29289C11.4804 3.10536 11.7348 3 12 3C12.2652 3 12.5196 3.10536 12.7071 3.29289C12.8946 3.48043 13 3.73478 13 4V12C13 12.2652 12.8946 12.5196 12.7071 12.7071C12.5196 12.8946 12.2652 13 12 13Z",
    fill: "#407DBB"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadReport);
export default __webpack_public_path__ + "static/media/download_report.eba50da709c7437bf35a958b1f1a1b55.svg";
export { ForwardRef as ReactComponent };